const Color = require('color');
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { InputSize } from '~/constants/form';
import * as React from 'react';
/* tslint:disable-next-line:import-name */
import ClickOutside from 'react-click-outside';
import { colors, zIndexValues } from '~/styles/constants';

const DropdownContainer = styled('div')<{ relativeToParent: boolean }>`
  ${(props) => (props.relativeToParent ? '' : 'position: relative;')};
  line-height: 1;
  width: inherit;
`;

const dropdownBorder = Color('#adadad').lighten(0.3).hex();

interface DropdownContentContainerProps {
  allowOverflow: boolean;
  minWidth?: string | InputSize;
  onClickOutside: (evt: React.MouseEvent) => void;
  reversed?: boolean;
  rightAlign?: boolean;
  openFromBottomToTop?: boolean;
  className?: string;
  disabled?: boolean;
}

const DropdownContentContainer = styled(ClickOutside, {
  shouldForwardProp: isPropValid,
})<DropdownContentContainerProps>`
  border-radius: 6px;
  position: absolute;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  z-index: ${zIndexValues.dropdown};
  background-color: white;
  ${(props) => (props.allowOverflow ? '' : 'overflow: hidden;')};
  ${(props) => (props.rightAlign ? '' : 'left: 0')};
  right: 0;
  min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : 'none')};

  ${(props) => (props.reversed ? 'bottom: 100%' : '')};
  ${(props) => (props.openFromBottomToTop ? 'bottom: 0' : '')};

  box-shadow:
    2px ${({ reversed }) => (reversed ? '-2px' : '2px')} 2px ${colors.form.greyBorder},
    -2px ${({ reversed }) => (reversed ? '0px' : '2px')} 2px ${dropdownBorder};
`;

export interface DropdownProps {
  isOpen?: boolean;
  minWidth?: string | InputSize;
  triggerComponent?(onClick?: () => void): React.ReactNode;
  onClickOutside?(evt?: React.MouseEvent): void;
  onClose?(): void;
  allowOverflow?: boolean;
  relativeToParent?: boolean;
  className?: string;
  reversed?: boolean;
  rightAlign?: boolean;
  openFromBottomToTop?: boolean;
  disabled?: boolean;
  size?: InputSize;
  children?: React.ReactNode;
}

class Dropdown extends React.Component<DropdownProps> {
  constructor(props: DropdownProps) {
    super(props);
  }

  closeDropDown = (evt?: React.MouseEvent) => {
    if (this.props.onClickOutside) {
      this.props.onClickOutside(evt);
    } else {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  };

  renderContent = () => {
    if (!this.props.isOpen) return null;

    return (
      <DropdownContentContainer
        className={this.props.className}
        allowOverflow={this.props.allowOverflow!}
        onClickOutside={this.closeDropDown}
        minWidth={this.props.minWidth}
        reversed={this.props.reversed}
        rightAlign={this.props.rightAlign}
        openFromBottomToTop={this.props.openFromBottomToTop}
      >
        {this.props.children}
      </DropdownContentContainer>
    );
  };

  render() {
    const { triggerComponent } = this.props;
    const trigger = triggerComponent ? triggerComponent() : null;

    return (
      <DropdownContainer relativeToParent={this.props.relativeToParent!}>
        {trigger}
        {this.renderContent()}
      </DropdownContainer>
    );
  }
}

export default Dropdown;
